module.exports = __webpack_public_path__ + "img/guojiadianwang.6528f1a2.png";